<div class="mul-admin">
  <ion-card>
    <ion-card-header>
      <ion-card-title>Igazolatlan mulasztás – értesítések</ion-card-title>
      <ion-card-subtitle>
        Ki kapjon üzenetet az igazolatlan mulasztásokról. A rendszer óránként nézi végig a mulasztásokat.
      </ion-card-subtitle>
    </ion-card-header>
    <ion-progress-bar type="indeterminate" *ngIf="betolt"></ion-progress-bar>

    <ion-card-content>
      <h3 class="cim">Értesítő a családnak</h3>
      <ion-list lines="none">
        <ion-item>
          <ion-toggle [(ngModel)]="b.szulo_ertesito" justify="space-between">
            Automatikus értesítő új igazolatlan óra után
            <div class="halvany">A gondviselők (a felügyeleti jog szerint) rendszerüzenetet és push-értesítést kapnak.</div>
          </ion-toggle>
        </ion-item>
        <ion-item *ngIf="b.szulo_ertesito">
          <ion-toggle [(ngModel)]="b.tanulo_is" justify="space-between">
            A tanuló is megkapja
          </ion-toggle>
        </ion-item>
        <ion-item *ngIf="b.szulo_ertesito">
          <ion-label class="ion-text-wrap">
            <div class="halvany">
              Tanköteles tanulónál az 1., 10., 30. és 50. igazolatlan óránál, nem tanköteles kiskorúnál a 10. óránál – tanulónként és
              küszöbönként egyszer. A 10/30/50 óránál az üzenet azt is közli, melyik hivatalos szervet értesíti az iskola (azok
              értesítése kézi teendő; a küszöbjelzés szól róla). Nagykorú, nem tanköteles tanulónak nincs automatikus értesítő.
            </div>
            <div class="halvany" *ngIf="kezdonapSzoveg">Az értesítő {{ kezdonapSzoveg }} indult; az akkor már elért küszöbökről nem ment értesítő.</div>
            <div class="halvany" *ngIf="!kezdonapSzoveg">Az első óránkénti kör csak feljegyzi a már elért küszöböket – régi mulasztásról nem megy értesítő.</div>
          </ion-label>
        </ion-item>
      </ion-list>

      <h3 class="cim">Küszöbjelzés és összesítő</h3>
      <p class="halvany">
        Jelzés, ha egy tanuló eléri az értesítési küszöböt (1, 10, 30, 50 óra), és a kötelező értesítés még nincs rögzítve;
        valamint összesítő a kiküldött szülői értesítőkről.
      </p>
      <ion-list lines="none">
        <ion-item>
          <ion-toggle [(ngModel)]="b.osztalyfonok" justify="space-between">Osztályfőnök és helyettese <div class="halvany">a saját osztályáról</div></ion-toggle>
        </ion-item>
        <ion-item>
          <ion-toggle [(ngModel)]="b.igazgato" justify="space-between">Igazgató <div class="halvany">igazgató / ig jogkör</div></ion-toggle>
        </ion-item>
        <ion-item>
          <ion-toggle [(ngModel)]="b.adminok" justify="space-between">Az intézmény adminisztrátorai <div class="halvany">minden Sulinform-admin jogú fiók</div></ion-toggle>
        </ion-item>
        <ion-item>
          <ion-toggle [(ngModel)]="b.osszesito" justify="space-between">Összesítő a kiküldött szülői értesítőkről <div class="halvany">a vezetői körnek (igazgató, adminok, név szerint felvettek)</div></ion-toggle>
        </ion-item>
      </ion-list>
      <div class="mezo">
        <label class="halvany">Név szerint is kapja</label>
        <ng-select appendTo="body" [items]="allomany" bindLabel="nev" bindValue="adid" [multiple]="true" [closeOnSelect]="false"
                   [(ngModel)]="b.szemelyek" placeholder="Munkatárs keresése" notFoundText="Nincs találat"></ng-select>
      </div>

      <div class="gombok">
        <ion-button (click)="toltes()" fill="outline" [disabled]="ment || betolt">Visszaállítás</ion-button>
        <ion-button (click)="mentes()" [disabled]="ment || betolt">Mentés</ion-button>
      </div>

      <h3 class="cim">Most ők kapják a vezetői üzeneteket</h3>
      <p class="halvany" *ngIf="!vezetok.length">Senki – a küszöbjelzést csak az osztályfőnök kapja{{ b.osztalyfonok ? '' : ' (de ő is ki van kapcsolva)' }}.</p>
      <table class="lista" *ngIf="vezetok.length">
        <tr *ngFor="let v of vezetok"><td>{{ v.nev }}</td><td class="halvany">{{ v.adid }}</td><td class="halvany">{{ v.ok }}</td></tr>
      </table>
      <p class="halvany" *ngIf="b.osztalyfonok">Mellettük az érintett osztályok osztályfőnökei a saját tanulóikról.</p>
      <p class="halvany">A „Igazolatlan mulasztás – küszöbjelzés” admin-területre (Adminisztrátori jogosultságok) felvett munkatárs mindig kapja.
        A mentés után a lista a mentett beállítást mutatja.</p>
    </ion-card-content>
  </ion-card>
</div>
